<template>
  <div class="wrap">
    <!-- <Header :class="`${fixedHeader ? 'fixedHeader' : 'absoluteHeader'}`" /> -->
    <Header :class="`${'fixedHeader'}`" />
    <div class="banner">
      <!-- <img src="../../assets/image/aboutus/abBanner.png" alt="" /> -->
      <img v-lazy="imgObj" alt="" />
    </div>
    <div class="main">
      <!-- 第一 -->
      <div class="first" ref="container">
        <img src="../../assets/image/aboutus/ab-first.png" alt="" />
        <div class="content">
          <h4>{{$t("aboutUsTitle1")}}</h4>
          <p>{{$t("aboutUsContent1")}}</p>
          <!-- <h4>About us</h4> -->
          <!-- <p>
            Seeder, headquartered in Singapore, was founded in 2020. With the
            technical support of artificial intelligence and machine learning,
            the company focuses on the fields of finance, e-commerce, banking,
            insurance, trust, security, logistics and so on. It can provide
            personalized and systematic information identification and risk
            control services for financial platforms such as banks, consumer
            financial institutions, installment and insurance. Through
            cooperation with operators, big data companies, banks and other
            institutions, intelligent data has been constructed from original
            big data, and artificial intelligence products such as
            human-evidence comparison, face detection, face search, risk face
            and structured recognition OCR information have been developed.
            Soon, anti-fraud, credit evaluation and intelligent risk control
            systems will be launched. All institutions can further improve their
            business efficiency through our service support.
          </p> -->
        </div>
      </div>
      <!-- 第二 -->
      <div class="second">
        <img src="../../assets/image/aboutus/ab-bottomBg.png" alt="" />
        <div class="picture">
          <!-- <img src="../../assets/image/aboutus/ab-bottom.png" alt="" /> -->
          <img
            v-if="launage === 'en_US'"
            src="../../assets/image/aboutus/ab-bottom.png"
            alt
          />
          <img
            v-if="launage === 'id'"
            src="../../assets/idImage/ab-bottom-id.png"
            alt
          />
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from "../../components/Header";
import Footer from "../../components/Footer";

export default {
  name: "AboutUs",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      launage : '',
      fixedHeader: false,
      // imgObj: {
      //   preLoad: 1,
      //   loading:require("../../assets/image/aboutus/ab-loading.jpg"),
      //   src: require("../../assets/image/aboutus/abBanner.png"),
      //   error: require("../../assets/image/error.jpg"),
      // },
    };
  },
  computed: {
    imgObj() {
      if(this.launage === 'en_US'){
        return {
          preLoad: 1,
          loading:require("../../assets/image/aboutus/ab-loading.jpg"),
          src: require("../../assets/image/aboutus/abBanner.png"),
          error: require("../../assets/image/error.jpg")
        };
      }else{
        return {
          preLoad: 1,
          loading:require("../../assets/idImage/compress_cn/abBanner-id.png"),
          src: require("../../assets/idImage/abBanner-id.png"),
          error: require("../../assets/image/error.jpg")
        };
      }
    }
  },
  created() {
    this.launage = this.$i18n.locale;
    //获取滚动条高度处理头部导航
    window.onscroll = () => {
      // console.log(e)
      this.fixedHeader = document.documentElement.scrollTop >= 60;
    };
  },
};
</script>
<style lang="less" scoped>
.wrap {
  width: 100%;
  .fixedHeader {
    position: fixed;
    background: black;
  }
  .absolute {
    position: absolute;
  }
}
.banner {
  width: 100%;
  min-height: 400px;
  img {
    display: block;
    width: 100%;
  }
}
.title {
  margin: auto;
  font-size: 32px;
  font-family: MicrosoftYaHei-Bold;
  font-weight: bold;
  color: #000000;
  display: flex;
  align-items: center;
  justify-content: center;
  .wire {
    margin-left: 20px;
    margin-right: 20px;
  }
}
.main {
  //第一
  .first {
    background: #fff;
    width: 100%;
    position: relative;
    img {
      width: 100%;
      display: block;
    }
    .content {
      width: 732px;
      position: absolute;
      top: 47%;
      left: 50%;
      transform: translate(-18%, -46%);
      z-index: 9;
      h4 {
        font-size: 32px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #071531;
        margin-bottom: 18px;
      }
      p {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #071531;
      }
    }
  }
  .second {
    width: 100%;
    position: relative;
    img {
      width: 100%;
      display: block;
    }
    .picture {
      width: 70%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .content {
        width: 537px;
        position: absolute;
        top: 40%;
        left: 50%;
        transform: translate(-90%, -80%);
        z-index: 9;
        h4 {
          font-size: 32px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #071531;
          margin-bottom: 18px;
        }
        p {
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #071531;
        }
      }
  }
}
</style>